<template>
    <!-- Generato da claude — Ricevute redesign Proposta A -->
    <div>
        <div class="card" v-if="socio.pagamenti && socio.pagamenti.length > 0">
            <div class="card-header card-header-background">
                <span class="dk-header-title">🧾 Le mie ricevute</span>
                <span class="dk-header-badge">{{socio.pagamenti.length}}</span>
            </div>
            <div class="card-body p-0">
                <div class="dk-list-item"
                    v-for="pagamento in socio.pagamenti"
                    :key="pagamento.ID_PAGAMENTO"
                    @click="esportaPagamento(pagamento)">
                    <div class="dk-list-icon">🧾</div>
                    <div class="dk-list-info">
                        <div class="dk-list-title">Ricevuta {{pagamento.NUMERO_RICEVUTA_FORMATTATO}}</div>
                        <div class="dk-list-sub">{{filters.formatDate(pagamento.DATA_PAGAMENTO)}}</div>
                    </div>
                    <div class="dk-list-action d-flex align-items-center gap-2">
                        <strong style="font-size:1rem; color:var(--dk-navy)">
                            € {{filters.formattaImporto(pagamento.IMPORTO)}}
                        </strong>
                        <i class="fas fa-download fa-sm" style="color:var(--dk-muted)"></i>
                    </div>
                </div>
            </div>
        </div>

        <div class="card" v-else>
            <div class="card-header card-header-background">
                <span class="dk-header-title">🧾 Le mie ricevute</span>
            </div>
            <div class="card-body p-0">
                <div class="dk-empty-state">
                    <span class="dk-empty-state-icon">🧾</span>
                    Nessuna ricevuta disponibile
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Ricevute',
    data: function() {
        return {
            filters: global.filters,
            socio: {},
        }
    },
    methods: {
        esportaPagamento(pagamento) {
            window.open(utils.BASE_API + 'deskalo/report?PAGAMENTI=' + pagamento.ID_PAGAMENTO + '&SESSION_TOKEN=' + utils.SESSION_TOKEN);
        },
    },
    created() {
        utils.ajax('/deskalo/socio', {}, (response) => {
            this.socio = response.data;
        });
    },
}
</script>
